module.exports = __webpack_public_path__ + "static/media/fa-solid-900.37bc7099.svg";